import axios from "axios";

const GSI_SRC = "https://accounts.google.com/gsi/client";

let loader = null;

// Client id + Workspace domain for the Google button. The backend owns both
// (config/adminlogin.php) so the button and the token check can never disagree.
export const getGoogleClient = () =>
  axios({
    url: process.env.REACT_APP_API_URL + "/login/google_client",
    method: "post",
    withCredentials: true,
  }).then((res) => {
    if (res.data.success === 1 && res.data.client_id) {
      return res.data;
    }
    throw new Error(
      "Google sign-in isn't set up yet. Please contact the tech team."
    );
  });

// Google Identity Services (the "Sign in with Google" button), loaded once per page.
export const loadGoogleIdentity = () => {
  if (window.google && window.google.accounts && window.google.accounts.id) {
    return Promise.resolve(window.google);
  }
  if (!loader) {
    loader = new Promise((resolve, reject) => {
      const script = document.createElement("script");
      script.src = GSI_SRC;
      script.async = true;
      script.defer = true;
      script.onload = () => resolve(window.google);
      script.onerror = () => {
        loader = null;
        reject(
          new Error("Couldn't reach Google. Check your connection and refresh.")
        );
      };
      document.head.appendChild(script);
    });
  }
  return loader;
};
